/*
 * Whoseland Map — canonical design tokens (JS export)
 *
 * Mirror of src/design-tokens.css. Import as:
 *
 *   import { ws } from "./theme";
 *   <Box sx={{ color: ws.color.ink, p: ws.space[4] }} />
 *
 * If you add or change a value here, change the matching CSS custom property
 * in src/design-tokens.css too. See DESIGN.md for the full token catalogue
 * and migration guidance.
 */

export const ws = {
  color: {
    ink: "#1F1F1F",
    body: "#413A36",
    muted: "#6B6B6B",
    faint: "#9C9282",
    inverse: "#FFFFFF",
  },

  surface: {
    page: "#FFFEF7",
    header: "#EFEBE2",
    bar: "#F6F2E8",
    card: "#FFFFFF",
    well: "#FAF8F2",
    inset: "#EFE9D8",
  },

  border: {
    subtle: "#EFEDE8",
    default: "#DDDAD4",
    strong: "#C9C2AE",
    inkline: "#1F1F1F",
    frame: "#E7DEC4",
  },

  accent: {
    brand: "#413A36",
    gold: "#C8A96E",
    pin: "#FFBF36",
    link: "#1a73e8",
  },

  status: {
    success: "#007C1D",
    warning: "#856404",
    warningBg: "#FFF3CD",
    danger: "#C34700",
    dangerBg: "#FBE9E7",
    infoBg: "#FFF6D9",
  },

  font: {
    body: "'Styrene A Trial', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
    head: "'Styrene B Trial', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
    mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },

  text: {
    xs: "0.6875rem",
    sm: "0.8125rem",
    base: "0.9375rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.375rem",
    "2xl": "1.75rem",
  },

  weight: {
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900,
  },

  leading: {
    tight: 1.2,
    snug: 1.4,
    base: 1.5,
  },

  // 4px base scale; index = px / 4 (except half-steps "0_5" and "1_5")
  space: {
    0: 0,
    "0_5": "2px",
    1: "4px",
    "1_5": "6px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "28px",
    8: "32px",
    10: "40px",
    12: "48px",
    16: "64px",
  },

  radius: {
    xs: "2px",
    sm: "4px",
    md: "8px",
    lg: "14px",
    pill: "9999px",
  },

  shadow: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.06)",
    md: "0 2px 8px rgba(0, 0, 0, 0.10)",
    lg: "0 10px 30px rgba(0, 0, 0, 0.18)",
    markerPin: "0 0 2px rgba(0, 0, 0, 0.6)",
  },

  z: {
    mapOverlay: 400,
    sidePanel: 1000,
    popover: 1300,
    modal: 1400,
    tooltip: 1500,
    toast: 1600,
  },

  motion: {
    fast: "120ms ease-out",
    base: "200ms ease",
    slow: "320ms ease-in-out",
  },

  // Matches MUI defaults; expressed as raw numbers for sx breakpoint use
  bp: {
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

export default ws;
